import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
});

api.interceptors.response.use(
  response => response.data,
  error => {
    const msg = error.response?.data?.message || '网络错误';
    return Promise.reject(new Error(msg));
  }
);

// Public APIs
export const getBanners = () => api.get('/other/public/banners');
export const getProducts = (params) => api.get('/portal/product', { params });
export const getProduct = (cid) => api.get(`/portal/product/${cid}`);

export default api;
